var _style, _path, _path2;

var _excluded = ["width", "height", "originalSize", "top", "bottom", "left", "right"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var toUnit = function toUnit(v) {
  return !v || /^([0-9]+(px|em|rem|%)|auto)/.test(v) ? v : v + 'px';
};

var SvgLivRentLogo = function SvgLivRentLogo(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '35px' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '35px' : _ref$height,
      originalSize = _ref.originalSize,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      rest = _objectWithoutProperties(_ref, _excluded);

  var hasStyle = !!top || !bottom || !!right || !!left;
  var style = hasStyle ? {
    marginTop: toUnit(top),
    marginBottom: toUnit(bottom),
    marginRight: toUnit(right),
    marginLeft: toUnit(left)
  } : {};
  var props = originalSize ? _objectSpread(_objectSpread({}, rest), {}, {
    style: style
  }) : _objectSpread(_objectSpread({}, rest), {}, {
    style: style,
    width: toUnit(width),
    height: toUnit(height)
  });
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "liv-rent-logo_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 2160 987.35"
    },
    viewBox: "0 0 2160 987.35"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".liv-rent-logo_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fe5f55}")), /*#__PURE__*/React.createElement("path", {
    d: "M1304.75 385.32h165.51v602.03h-165.51zm541.42 282 139.3-282H2160l-315.02 602.03-312.53-602.03h173.86zm-543.26-508c0-22.85 8.41-42.92 24.86-59.45 16.46-16.54 36.58-24.99 59.62-24.99 23.34 0 43.64 8.44 59.99 24.87 16.55 16.25 24.97 36.54 24.97 60.06 0 23.47-8.39 43.87-24.75 60.3-16.16 16.64-36.35 25.11-59.74 25.11-23.34 0-43.64-8.43-60.11-24.99-16.47-16.57-24.84-37.14-24.84-60.91zM1025.58 0h168.96v987.35h-168.96z",
    style: {
      fill: "#fff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M509.46 608.64 338.14 744.13v243.22h342.64V744.13z",
    className: "liv-rent-logo_svg__st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m337.92 987.35.22-243.46L0 987.35V0h338.14v987.35z",
    className: "liv-rent-logo_svg__st1"
  })));
};

export { SvgLivRentLogo as ReactComponent };
export default "/_next/static/media/liv-rent-logo.d4f267b2.svg";